module.exports = __webpack_public_path__ + "static/media/settings-work-tool.2de4a89f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/settings-work-tool.svg
// module id = 983
// module chunks = 7